module.exports = __webpack_public_path__ + "static/media/edit.5da04355.svg";